import React from 'react'
import PropTypes from 'prop-types'
import { Box, Icon, Tooltip } from '@maui/elements'
import isEmpty from 'lodash/isEmpty'

import { RatingValueWithFreemium, YesOrNoWithFreemium } from './ComponentsWithFreemium'
import { cveColorTheme } from './colorMaps'

export const SeveritySummary = ({ exploitRating, risk, inTheWild, zeroDay, isPredicted }) => {
  const theme = cveColorTheme
  const zeroDayColor = zeroDay ? theme.cve.critical.color : theme.cve.default.color
  const inWildColor = inTheWild ? theme.cve.critical.color : theme.cve.default.color

  const riskKey = risk?.toLowerCase()

  const toolTipContent = 'The "Exploited in the Wild" filter indicates when Mandiant has either directly observed malicious exploitation of a vulnerability or has received information regarding confirmed exploitation from a reliable source.'
  const vulnerabilityRiskRatingContent = "Mandiant assigns a risk rating to each vulnerability, either manually by an Analyst or using Mandiant's Predicted Risk Rating (PRR). The PRR model replicates the manual process used by analysts to consider numerous technical details, and then compares the results to the analyst ratings for similar, manually rated vulnerabilities."

  return (
    <Box display="flex" flexWrap="wrap" gap="8">
      {!isEmpty(riskKey) && (
        <Box flexBasis="25%">
          <Box color="colorTextDeemphasis" mb="spaceGapMedium">
            Risk Rating{' '}
            <Tooltip
              color="white"
              portal
              size="large"
              textStyle="bodyMain"
              tooltip={vulnerabilityRiskRatingContent}
            >
              <Icon name="info" verticalAlign="top" />
            </Tooltip>
          </Box>
          <RatingValueWithFreemium
            color={theme.cve[riskKey]?.color || theme.cve.default.color}
            value={riskKey}
            isPredicted={isPredicted}
          />
        </Box>
      )}
      <Box flexBasis="25%">
        <Box color="colorTextDeemphasis" mb="spaceGapMedium">Exploitation State</Box>
        <RatingValueWithFreemium
          color={theme.cve[exploitRating?.toLowerCase()]?.color || theme.cve.default.color}
          value={exploitRating || 'No Known'}
        />
      </Box>
      <Box flexBasis="25%">
        <Box color="colorTextDeemphasis" mb="spaceGapMedium">Exploited as Zero-Day</Box>
        <YesOrNoWithFreemium
          color={zeroDayColor}
          value={zeroDay}
        />
      </Box>
      <Box flexBasis="25%">
        <Box color="colorTextDeemphasis" mb="spaceGapMedium">
          Exploited in the Wild{' '}
          <Tooltip
            color="white"
            portal
            size="large"
            textStyle="bodyMain"
            tooltip={toolTipContent}
          >
            <Icon name="info" verticalAlign="top" />
          </Tooltip>
        </Box>
        <YesOrNoWithFreemium
          color={inWildColor}
          value={inTheWild}
        />
      </Box>
    </Box>
  )
}

SeveritySummary.propTypes = {
  attackEase: PropTypes.shape({
    length: PropTypes.any,
    toLowerCase: PropTypes.func
  }),
  exploitRating: PropTypes.string,
  inTheWild: PropTypes.string,
  risk: PropTypes.shape({
    toLowerCase: PropTypes.func
  }),
  zeroDay: PropTypes.string
}
